import { useEffect, useRef, useState } from 'react';
import { t } from './i18n';
import { supabase } from './supabaseClient';
import { clientDinStare } from './conectare';

export default function LinkedInCallback() {
  const [status, setStatus] = useState(t('linkedin', 'seConecteaza'));
  // Codul de autorizare e de UNICA FOLOSINTA. In dezvoltare, React.StrictMode
  // executa efectele de doua ori, deci fara garda asta se cheama `linkedin-oauth`
  // de doua ori cu acelasi cod: prima cerere il consuma, a doua primeste
  // „does not match authorization code" — sau, si mai rau, cele doua cereri
  // concurente se anuleaza reciproc si NU se salveaza niciun token.
  //
  // Costul e mare, nu cosmetic: reautorizarea la LinkedIn REVOCA tokenul
  // anterior. Deci o conectare esuata nu doar ca nu repara, ci omoara tokenul
  // care mai era in baza, iar butonul continua sa arate „Conectat" fiindca se
  // uita doar daca exista un rand. Ne-a costat patru ore pe 10 septembrie 2026.
  //
  // useRef, nu useState: nu trebuie sa provoace o randare, si trebuie citit
  // sincron, inainte ca a doua executie sa apuce sa porneasca cererea.
  const pornit = useRef(false);

  useEffect(() => {
    if (pornit.current) return;
    pornit.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const stareIntoarsa = params.get('state');
    const errorCode = params.get('error');
    const errorMessage = params.get('error_description');

    if (errorCode) {
      console.log('Eroare LinkedIn:', errorCode, errorMessage);
      setStatus(t('linkedin', 'eroareConectare'));
      setTimeout(() => { window.location.href = `/?error=linkedin_${errorCode}`; }, 1500);
      return;
    }

    if (!code || !stareIntoarsa) {
      window.location.href = '/';
      return;
    }

    // Intoarcerea trebuie sa fie raspunsul la o plecare din browserul acesta (vezi conectare.js).
    const state = clientDinStare(stareIntoarsa);
    if (!state) {
      console.error('Conectare oprita: codul de la intoarcere nu e cel de la plecare.');
      setStatus(t('linkedin', 'eroareConectare'));
      setTimeout(() => { window.location.href = '/?error=linkedin_stare'; }, 1500);
      return;
    }

    async function proceseazaCallback() {
      try {
        setStatus(t('linkedin', 'seProceseaza'));
        // Acelasi redirect_uri ca la autorizare, altfel LinkedIn refuza schimbul.
        const redirectUri = window.location.origin + '/auth/linkedin/callback';
        // Sesiunea utilizatorului, nu cheia publica: functia verifica cine cheama si
        // daca are drept pe clientul din `state` (15 septembrie 2026, SECURITATE_PLAN.md).
        // Fara sesiune ne oprim INAINTE de schimbul codului, ca sa nu consumam o
        // autorizare LinkedIn degeaba (reautorizarea revoca tokenul anterior).
        const { data: sesiune } = await supabase.auth.getSession();
        const tokenSesiune = sesiune?.session?.access_token;
        if (!tokenSesiune) {
          console.error('Eroare linkedin-oauth: nu exista sesiune');
          setStatus(t('linkedin', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_fara_sesiune`; }, 2000);
          return;
        }
        const res = await fetch(
          `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/linkedin-oauth?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}&redirect_uri=${encodeURIComponent(redirectUri)}`,
          {
            headers: {
              'Authorization': `Bearer ${tokenSesiune}`,
              'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY
            }
          }
        );
        if (!res.ok) {
          let detaliu = '';
          try { const j = await res.json(); detaliu = j.error || j.detail || ''; } catch (e) {}
          console.error('Eroare linkedin-oauth:', res.status, detaliu);
          // Un cont de retea tine de un singur client. Cel mai des: browserul e logat pe retea cu
          // contul altui client (vazut pe viu pe 9 octombrie 2026, la Jackpot, cu contul lui Dan).
          if (detaliu === 'cont_legat_de_alt_client') {
            setStatus(t('callback', 'contLegat'));
            setTimeout(() => { window.location.href = `/?error=cont_legat`; }, 9000);
            return;
          }
          setStatus(t('linkedin', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
          return;
        }
        setStatus(t('linkedin', 'conectatRedirect'));
        window.location.href = `/?linkedin=connected&client=${state}`;
      } catch (err) {
        console.error('Eroare OAuth:', err);
        setStatus(t('linkedin', 'eroareConectare'));
        setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
      }
    }

    proceseazaCallback();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Sans, sans-serif', color: '#1A6B3C' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
        <div>{status}</div>
      </div>
    </div>
  );
}
